<!-- src/components/ArticleCard.vue -->
<template>
  <div class="article-card">
    <img :src="article.image" :alt="article.title" />
    <div class="article-info">
      <h3>{{ article.title }}</h3>
      <p>{{ article.summary }}</p>
      <router-link
        :to="{ name: 'Article', params: { section: section, id: article.id } }"
      >
        Read More
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArticleCard',
  props: {
    article: {
      type: Object,
      required: true,
    },
    section: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.article-card {
  border: 1px solid #ddd;
  margin-bottom: 20px;
  display: flex;
}

.article-card img {
  width: 200px;
  object-fit: cover;
}

.article-info {
  padding: 15px;
}

.article-info h3 {
  margin-top: 0;
}

.article-info p {
  margin: 10px 0;
}
</style>